import { Radio, Tag } from "antd";
import React, { Fragment, useContext, useEffect, useState } from "react";
import trans, { isRTL } from "../../../utils";
import Button from "../../Helpers/Button/Button";
import {
	useGetAllConfigurationsQuery,
	useGetSingleOfflineConfigurationQuery,
} from "../../../Redux/service/Configuration/Configuration";
import { popupcontext } from "../../../context/Popupscontext";
import Delete from "../../Helpers/Delete/DeletePopup";
import Loader from "../../Helpers/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
	deleteData,
	getAllData,
	getData,
	storeData,
} from "../../../utils/IndexedDB";
import { useDispatch, useSelector } from "react-redux";
import {
	setConfigId,
	setOfflineModules,
} from "../../../Redux/service/Users/UsersSlice";
import ViewOfflineConfig from "./ViewOfflineConfig";
import { filtrationcontext } from "../../../context/Filtercontext";
import { useLazyGetOfflineIRsQuery } from "../../../Redux/service/IR/IR";

export default function OfflineConfigData({ searchQuery }) {
	const {
		reloadData,
		setReloadData,
		setConfigurationId,
		setIsDeleting,
		setDeleted,
		deleted,
		currentConfigurationId,
		isDeleting,
		highlight,
	} = useContext(popupcontext);
	const { setLoader } = useContext(filtrationcontext);
	const dispatch = useDispatch();
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const configId = useSelector((state) => state.users.configId);
	const [selectedConfig, setSelectedConfig] = useState(null);
	const [limit, setLimit] = useState(10);
	const { data, refetch, isLoading, isError, error } =
		useGetAllConfigurationsQuery(
			{
				page: 1,
				limit: limit,
				search: searchQuery,
			},
			{
				refetchOnMountOrArgChange: limit > 10 ? true : false,
				skip: offlineMode,
			},
		);
	const [
		getFilteredIR,
		{ isError: FilteredIRIsError, error: FilteredIRError },
	] = useLazyGetOfflineIRsQuery();
	const id = currentConfigurationId || selectedConfig;
	console.log("selectedConfig", selectedConfig, "id", id);

	const {
		data: OfflineConfig,
		isFetching: OfflineConfigLoading,
		isLoading: OfflineLoading,
		refetch: refetchOfflineConfig,
	} = useGetSingleOfflineConfigurationQuery(id, {
		skip: !id || (isDeleting && currentConfigurationId) || offlineMode,
		refetchOnMountOrArgChange: true,
	});
	useEffect(() => {
		if (!OfflineConfig?.data?.layoutUrl) return;

		const cacheImage = async () => {
			const url = OfflineConfig.data.layoutUrl;

			const cache = await caches.open("navigations");

			const cached = await cache.match(url);
			if (cached) {
				console.log("Image already cached");
				return;
			}

			const response = await fetch(url);
			await cache.put(url, response.clone());

			console.log("Image prefetched and cached");
		};

		cacheImage();
	}, [OfflineConfig]);
	const navigate = useNavigate();
	useEffect(() => {
		if (reloadData) {
			refetch();
			if (id) refetchOfflineConfig();
			setReloadData(false);
		}
	}, [reloadData]);
	useEffect(() => {
		if (deleted) {
			refetch();
			setDeleted(false);
		}
	}, [deleted]);
	useEffect(() => {
		if (!isError) return;

		if (error?.status === 500) {
			toast.error(trans("Server error, please try again later"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		} else if (error?.status === 401) {
			toast.error(trans("Unauthorized request"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		} else {
			toast.error(error?.data?.message || trans("Request failed"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar" ? true : false,
			});
		}
	}, [isError, error]);
	const truncateText = (text, maxLength = 35) => {
		if (!text) return "";
		return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
	};
	useEffect(() => {
		if (OfflineConfigLoading) {
			toast.info(trans("Preparing Offline Configuration Data"), {
				autoClose: false,
				rtl: localStorage.getItem("lang") === "ar",
			});
		} else if (!OfflineLoading) {
			toast.dismiss();
		}
	}, [OfflineConfigLoading, OfflineLoading]);
	// useEffect(() => {
	// 	const initDB = async () => {
	// 		if (offlineMode) {
	// 			if (!OfflineConfig?.data) return;

	// 			await storeData(
	// 				"OfflineModeData",
	// 				"configurationStore",
	// 				"configuration",
	// 				OfflineConfig.data,
	// 			);
	// 		} else {
	// 			await deleteData(
	// 				"OfflineModeData",
	// 				"configurationStore",
	// 				"configuration",
	// 			);
	// 		}
	// 	};

	// 	initDB();
	// }, [offlineMode, OfflineConfig]);
	const [item, setItem] = useState(null);
	useEffect(() => {
		const initDB = async () => {
			try {
				const data = await getData(
					"OfflineModeData",
					"configurationStore",
					"configuration",
				);
				console.log("DbData", data);
				setItem(data);
			} catch (error) {
				console.error("IndexedDB read error:", error);
			}
		};

		initDB();
	}, []);
	const [isLoadingOfflineData, setIsLoadingOfflineData] = useState(false);
	const downloadFormPDF = async (allData) => {
		const baseUrl = process.env.REACT_APP_BACKEND2_URL || "";
		const url = `${baseUrl}/v1/inspection-requests/${allData.id}/hdb_pdf?revisionNumber=${allData.revision_number}&revisionType=${allData.revision_type}`;

		const fileKey = `${allData?.ir_number || allData?.id}-Rev-${allData.revision_number}`;

		try {
			// ✅ Check if already exists in IndexedDB
			const existing = await getData("OfflineModeData", "PDFFiles", fileKey);
			if (existing?.blob) {
				console.log(`PDF already cached, skipping: ${fileKey}`);
				return;
			}

			const response = await fetch(url, {
				method: "GET",
				headers: {
					Authorization: `Bearer ${localStorage.getItem("token")}`,
				},
			});

			if (!response.ok) throw new Error("Failed to download PDF");

			const blob = await response.blob();

			await storeData("OfflineModeData", "PDFFiles", fileKey, {
				blob,
				ir_number: allData?.ir_number,
				id: allData?.id,
				revision_number: allData.revision_number,
			});

			console.log(`PDF saved to IndexedDB: ${fileKey}`);
		} catch (error) {
			console.error("Error saving PDF:", error);
		}
	};
	useEffect(() => {
		const handleStorage = async () => {
			if (offlineMode) {
				if (!OfflineConfig?.data) return;
				try {
					setIsLoadingOfflineData(true);
					setLoader(true);
					let finalData = { ...OfflineConfig.data };

					if (OfflineConfig.data.layoutUrl) {
						const response = await fetch(OfflineConfig.data.layoutUrl);
						const blob = await response.blob();
						const base64data = await new Promise((resolve) => {
							const reader = new FileReader();
							reader.onloadend = () => resolve(reader.result);
							reader.readAsDataURL(blob);
						});
						finalData.layoutUrlBase64 = base64data;
					}

					await storeData(
						"OfflineModeData",
						"configurationStore",
						"configuration",
						finalData,
					);
					const filterIRdata = await getFilteredIR({
						queryString: `level_id=${OfflineConfig.data?.levelId}&discipline=${OfflineConfig.data.modules?.filter((mod) => mod.module === "IR")[0]?.discipline}`,
					}).unwrap();
					console.log("Filtered IR Data", filterIRdata);
					filterIRdata?.data?.forEach(async (ir) => {
						await storeData("OfflineModeData", "IR", ir?.ir_number, {
							configurationName: OfflineConfig.data?.name,
							uid: ir?.id,
							...ir,
						});
					});
					filterIRdata?.data?.forEach(async (ir) => {
						await downloadFormPDF(ir);
					});
					// ✅ UPDATE STATE MANUALLY AFTER SAVING
					setItem(finalData);

					console.log("Offline data synced and state updated.");
				} catch (error) {
					console.error("Error saving offline data:", error);
				} finally {
					setIsLoadingOfflineData(false);
					setLoader(false);
				}
			} else {
				try {
					await deleteData(
						"OfflineModeData",
						"configurationStore",
						"configuration",
					);
					const data = await getAllData("OfflineModeData", "IR");
					data
						?.filter((ir) => ir.status && !ir.statusSync)
						?.forEach(async (ir) => {
							await deleteData("OfflineModeData", "IR", ir?.id);
							await deleteData(
								"OfflineModeData",
								"PDFFiles",
								`${ir?.ir_number || ir?.id}-Rev-${ir.revision_number}`,
							);
						});
					// ✅ CLEAR STATE MANUALLY AFTER DELETING
					setItem(null);

					console.log("Offline data cleared.");
				} catch (error) {
					console.error("Error deleting offline data:", error);
				}
			}
		};

		handleStorage();
	}, [OfflineConfig, offlineMode]);

	console.log("ITEMDATA", item);

	if (isLoading || (offlineMode && isLoadingOfflineData)) {
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	}
	console.log("SelectedConfig", selectedConfig);
	return (
		<>
			<div
				style={{
					height: "calc(100vh - 225px)",
					overflowY: "auto",
					border: "1px solid #E0E0E0",
					borderRadius: "20px",
					marginTop: "8px",
					padding: "8px",
				}}
			>
				{searchQuery && data?.data?.length === 0 && (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexDirection: "column",
							height: "100%",
						}}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/EmptyTable.svg`}
							alt="empty"
							style={{ marginBottom: "30px" }}
						/>
						<p
							style={{
								marginBottom: "4px",
								fontSize: "16px",
								fontWeight: "500",
							}}
						>
							{trans("Configuration is not Found")}
						</p>
					</div>
				)}
				{!searchQuery && data?.data?.length === 0 && (
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							flexDirection: "column",
							height: "100%",
						}}
					>
						<img
							src={`${process.env.PUBLIC_URL}/assets/New/Randoms/EmptyTable.svg`}
							alt="empty"
							style={{ marginBottom: "30px" }}
						/>
						<p
							style={{
								marginBottom: "4px",
								fontSize: "16px",
								fontWeight: "500",
							}}
						>
							{trans("No Configuration Created Yet")}
						</p>
						<span
							style={{
								color: "#00000099",
								fontSize: "14px",
								marginBottom: "30px",
							}}
						>
							{trans("Create your first one now!")}
						</span>
						<Button
							text={trans("Create New Configuration")}
							type={"primary"}
							onClick={() => navigate("/setup/offline-setup-control")}
						/>
					</div>
				)}
				{!offlineMode ? (
					<div className="row">
						{data?.data?.map((item) => (
							<div
								className="col-lg-6"
								key={item?.id}
								onClick={(e) => {
									e.stopPropagation();
									if (isDeleting) return;
									setSelectedConfig(item?.id);
								}}
							>
								<div
									className="offline-config-data"
									style={{ cursor: "pointer" }}
								>
									<div className="offline-config-card">
										<div className="flex-between mb-2">
											<div
												title={item.name}
												style={{ fontWeight: "600", fontSize: "18px" }}
											>
												{truncateText(item.name)}
											</div>
											<Radio
												className={highlight ? "radio-glow" : ""}
												title={"offline-config"}
												onClick={(e) => {
													e.stopPropagation();
													setConfigurationId(
														currentConfigurationId === item?.id
															? null
															: item?.id,
													);
													dispatch(
														setConfigId(
															currentConfigurationId === item?.id
																? null
																: item?.id,
														),
													);
													dispatch(setOfflineModules(item)); // ← store in) Redux
												}}
												checked={
													configId === item?.id &&
													!isDeleting &&
													OfflineConfig?.status === "success"
												}
											/>
										</div>

										<div className="offline-config-card-cached-details">
											<div className="offline-config-card-cached-details-title">
												{trans("available to cache")}
											</div>
											<div
												className="d-flex"
												style={{
													color: "#42526E",
													flexWrap: "wrap",
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
												}}
											>
												<div>
													{`${item?.project?.name} - ${item?.building?.name} - ${item?.level?.name}`}
												</div>
												{item?.modules?.length > 0 &&
													item?.modules?.map((mod, idx) => (
														<div
															key={idx}
															style={{
																width: "100%",
																display: "flex",
																alignItems: "center",
																marginBlock: "4px",
															}}
														>
															<div>{trans(mod?.module)}</div>
															<div
																className="flex-between"
																style={{ marginInline: "46px" }}
															>
																<img
																	src={`${process.env.PUBLIC_URL}/assets/New/OfflineMode/Folder.svg`}
																	alt="folder"
																	style={{
																		marginRight: !isRTL && "3px",
																		marginLeft: isRTL && "3px",
																	}}
																/>
																{mod?.module === "IR" ? (
																	<div>{`${trans("form")} - ${mod?.formName}`}</div>
																) : (
																	<div>{`${trans("sector")} - ${mod?.sector}`}</div>
																)}
															</div>
															<div className="flex-between">
																<img
																	src={`${process.env.PUBLIC_URL}/assets/New/OfflineMode/Discipline.svg`}
																	alt="discpline"
																	style={{
																		marginRight: !isRTL && "3px",
																		marginLeft: isRTL && "3px",
																	}}
																/>
																<div>
																	{`${trans("discipline")} - ${trans(mod?.discipline)}`}
																</div>
															</div>
														</div>
													))}
											</div>
										</div>
										<div className="flex-between">
											<Button
												type="primary"
												text={trans("Reconfigure")}
												img="/New/OfflineMode/Reconfig.svg"
												style={{
													width: "89%",
													height: "36px",
													borderRadius: "8px",
													background:
														"linear-gradient(90deg, #2E9245 0%, #0F6936 100%)",
													boxShadow: "0px 2px 24px rgba(46, 146, 69, 0.24)",
												}}
												onClick={(e) => {
													e.stopPropagation();
													setConfigurationId(item?.id);
													navigate(`/setup/offline-setup-control/${item?.id}`);
												}}
											/>
											<div
												className="offline-config-delete"
												title={trans("Delete")}
												onClick={async (e) => {
													e.stopPropagation();
													setSelectedConfig(null);
													setIsDeleting(true);
													setConfigurationId(item?.id);
												}}
											>
												<img
													src={`${process.env.PUBLIC_URL}/assets/New/OfflineMode/Bin.svg`}
													alt="bin"
												/>
											</div>
										</div>
									</div>
								</div>
								<Delete configId={item?.id} />
							</div>
						))}
					</div>
				) : (
					<div className="w-100">
						<div className="offline-config-data">
							<div className="offline-config-card">
								<div className="w-100 d-flex align-items-center">
									<div
										title={item?.name}
										style={{ fontWeight: "600", fontSize: "18px" }}
									>
										{truncateText(item?.name)}
									</div>
									<Tag color="green" style={{ marginInline: "8px" }}>
										{trans("Ready")}
									</Tag>
								</div>

								<div className="offline-config-card-cached-details mt-2">
									<div className="offline-config-card-cached-details-title">
										{trans("cached details")}
									</div>
									<div
										style={{
											color: "#42526E",
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
										}}
									>
										<div>
											{`${item?.project?.name} - ${item?.building?.name} - ${item?.level?.name}`}
										</div>
										{item?.modules?.length > 0 &&
											item?.modules?.map((mod, idx) => (
												<div
													key={idx}
													style={{
														width: "100%",
														display: "flex",
														alignItems: "center",
														marginBlock: "4px",
													}}
												>
													<div>{trans(mod?.module)}</div>
													<div
														className="flex-between"
														style={{ marginInline: "46px" }}
													>
														<img
															src={`${process.env.PUBLIC_URL}/assets/New/OfflineMode/Folder.svg`}
															alt="folder"
															style={{
																marginRight: !isRTL && "3px",
																marginLeft: isRTL && "3px",
															}}
														/>
														{mod?.module === "IR" ? (
															<div>{`${trans("form")} - ${mod?.formName}`}</div>
														) : (
															<div>{`${trans("sector")} - ${mod?.sector}`}</div>
														)}
													</div>
													<div className="flex-between">
														<img
															src={`${process.env.PUBLIC_URL}/assets/New/OfflineMode/Discipline.svg`}
															alt="discpline"
															style={{
																marginRight: !isRTL && "3px",
																marginLeft: isRTL && "3px",
															}}
														/>
														<div>
															{`${trans("discipline")} - ${trans(mod?.discipline)}`}
														</div>
													</div>
												</div>
											))}
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
				{data?.paginationInfo?.nextPage !== "-" && !isError && !offlineMode && (
					<div
						style={{
							width: "100%",
							display: "flex",
							justifyContent: "center",
							marginTop: "12px",
						}}
					>
						<Button
							type="default"
							htmlType="button"
							text={trans("Load More")}
							style={{
								width: "200px",
								height: "36px",
								borderRadius: "8px",
							}}
							onClick={() => setLimit((prev) => prev + 10)}
						/>
					</div>
				)}
			</div>
			<ViewOfflineConfig
				selectedConfig={selectedConfig}
				data={OfflineConfig?.data}
				setSelectedConfig={setSelectedConfig}
			/>
		</>
	);
}
